import { Checked2 } from '@uikit/icons/Checked2';
import { Clock } from '@uikit/icons/Clock';
import { CloseCircle } from '@uikit/icons/CloseCircle';

import type { Sorts } from '@shared/api/types/magicWall';

export const DEFAULT_FILTER = 'index';

export type Sort = { id: Sorts; name: string };

export const OFFER_STATUS_CONFIG = {
  APPROVED: {
    label: 'Completed',
    Icon: Checked2,
    className: 'text-green-700',
  },
  REJECTED: {
    label: 'Rejected',
    Icon: CloseCircle,
    className: 'text-red-600',
  },
  PENDING: {
    label: 'In Review',
    Icon: Clock,
    className: 'text-yellow-600',
  },
} as const;

export const extraFilters = {
  id: 0,
  type: 'HOT_OFFER_CATEGORY',
  attributes: {
    key: 'all',
    name: 'All',
  },
};

export const sortTypes: Sort[] = [
  {
    id: 'index',
    name: 'Default',
  },
  {
    id: 'date_asc',
    name: 'Oldest',
  },
  {
    id: 'date_desc',
    name: 'Newest',
  },
  {
    id: 'sqr_desc',
    name: 'Highest SQR',
  },
  {
    id: 'sqr_asc',
    name: 'Lowest SQR',
  },
  {
    id: 'karma_desc',
    name: 'Highest Karma',
  },
  {
    id: 'karma_asc',
    name: 'Lowest Karma',
  },
];
